import Axios from 'axios';

const API_URL =  process.env.API_URL + '/api/v1/';

class SyaratKetentuan {
  index() {
    return Axios.get(API_URL + 'syaratketentuan-list');
  }

  show(syaratketentuan) {
    return Axios.get(API_URL + `syaratketentuan/${syaratketentuan}`);
  }
}

export default new SyaratKetentuan();



// WEBPACK FOOTER //
// ./src/api/syaratketentuan.js